import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerAttributesModalComponent } from './historical-customer-attributes-modal.component';
import { HistoricalCustomerAttributesComponent } from './historical-customer-attributes.component';

@NgModule({
    declarations: [
        HistoricalCustomerAttributesComponent,
        HistoricalCustomerAttributesModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerAttributesComponent,
        HistoricalCustomerAttributesModalComponent
    ]
})

export class HistoricalCustomerAttributesModule { }
